module.exports = __webpack_public_path__ + "static/face-4-a68b7f6ff97cdc0a01a2b6ab15d5d403.png";